import { useState } from "react";
import Footer from "../components/Footer";
import { api, downloadUrl, formatErr } from "../lib/api";

export default function Recover() {
  const [email, setEmail] = useState("");
  const [purchases, setPurchases] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setPurchases(null); setLoading(true);
    try {
      const r = await api.post("/recover", { email: email.trim().toLowerCase() });
      setPurchases(r.data.purchases || []);
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20">
        <p className="text-[0.7rem] tracking-[0.32em] uppercase" style={{ color: "var(--opus-sage)" }}>Already purchased?</p>
        <h1 className="font-display mt-3" style={{ fontSize: "clamp(2.2rem, 5vw, 3.4rem)", fontWeight: 500, letterSpacing: "0.01em" }}>Recover your downloads.</h1>
        <span className="opus-rule mt-5 block" />
        <p className="font-body mt-5 leading-relaxed" style={{ color: "var(--opus-text-secondary)" }}>
          Enter the email you used at checkout — we'll show every resource you've purchased and give you fresh download links.
        </p>

        <form onSubmit={submit} className="mt-8" data-testid="recover-form">
          <label className="text-[0.7rem] tracking-[0.28em] uppercase block mb-2 font-body">Email</label>
          <input
            type="email"
            required
            data-testid="recover-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            className="opus-input"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="recover-submit"
            className="btn-sage mt-5 px-7 py-3 text-[0.72rem] tracking-[0.3em] uppercase disabled:opacity-50"
            style={{ borderRadius: "2px" }}
          >
            {loading ? "Looking…" : "Find my purchases"}
          </button>
          {error ? <p className="text-sm mt-3 font-body" style={{ color: "#A0392C" }}>{error}</p> : null}
        </form>

        {purchases !== null ? (
          <div className="mt-12" data-testid="recover-results">
            {purchases.length === 0 ? (
              <p className="font-display text-2xl" style={{ color: "var(--opus-text-secondary)" }}>
                No purchases found for this email.
              </p>
            ) : (
              <ul className="space-y-4">
                {purchases.map((p, i) => (
                  <li
                    key={i}
                    className="opus-card p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4"
                    data-testid={`recover-item-${i}`}
                  >
                    <div>
                      <p className="font-display text-xl" style={{ color: "var(--opus-text)" }}>{p.product_title}</p>
                      <p className="text-[0.7rem] uppercase tracking-[0.25em] mt-1 font-body" style={{ color: "var(--opus-text-muted)" }}>
                        Purchased {new Date(p.created_at).toLocaleDateString()} · ${p.amount?.toFixed?.(2) ?? p.amount}
                      </p>
                    </div>
                    <a
                      href={downloadUrl(p.download_token)}
                      data-testid={`recover-download-${i}`}
                      className="btn-sage px-5 py-2.5 text-[0.7rem] tracking-[0.28em] uppercase"
                      style={{ borderRadius: "2px" }}
                    >
                      Download ↓
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : null}
      </section>
      <Footer />
    </div>
  );
}
